import React from 'react';
import AmenityUtils from '@spothero/utils/amenity';
import { AmenityTypes } from 'utils/types/amenity';
import { Flex, Text, Icon } from '@spothero/ui';
const INSTANT_ACCESS_TEXT = 'Instant Access';
const AmenitiesInfo = ({ amenities }) => {
    const isInstantAccess = amenities?.some(amenity => amenity?.type === AmenityTypes.IMMEDIATE_PARKING);
    if (!isInstantAccess) {
        return null;
    }
    const InstantAccessIcon = AmenityUtils.getIcon(AmenityTypes.IMMEDIATE_PARKING) || null;
    return (isInstantAccess && (<Flex alignItems="center" gap="1" mt="1" data-testid="Amenity-InstantAccess">
                {InstantAccessIcon && (<Icon as={AmenityUtils.getIcon(AmenityTypes.IMMEDIATE_PARKING)} color="gray.500" data-testid="Amenity-InstantAccess-icon"/>)}
                <Text fontSize="sm">{INSTANT_ACCESS_TEXT}</Text>
            </Flex>));
};
export default AmenitiesInfo;
